import CenterSpinner from '@otovo/shared/components/LoadingScreens/CenterSpinner';
import { Otovo$Config } from '@otovo/shared/types/otovoweb';
import { Sanity$CampaignPage } from '@otovo/shared/types/sanityTypes';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';

const StorefrontPage = dynamic(() => import('../StorefrontPage'));
const SanityLandingPage = dynamic(() => import('./SanityLandingPage'));
const SanityLandingPageV2 = dynamic(
  () => import('../v2/Sanity/SanityLandingPage'),
);
const StorefrontPageV2 = dynamic(() => import('../v2/StorefrontPage'));

type Props = {
  config: Otovo$Config;
  sanityDocument: Sanity$CampaignPage;
};

const NEW_DESIGN_TEST_SLUGS = [
  'zolar-kunden',
  'care-sepa-success',
  'care-sepa-exit',
];

const GenericLandingPage = ({ config, sanityDocument }: Props) => {
  const router = useRouter();
  const { hideMenu, hideFooter } = sanityDocument || {};

  if (router.isFallback) {
    return <CenterSpinner />;
  }

  if (
    NEW_DESIGN_TEST_SLUGS.some((slug) => slug === sanityDocument?.slug?.current)
  ) {
    return (
      <StorefrontPageV2
        config={config}
        hideMenu={hideMenu}
        hideFooter={hideFooter}
      >
        <SanityLandingPageV2 page={sanityDocument} />
      </StorefrontPageV2>
    );
  }

  return (
    <StorefrontPage
      config={config}
      hideMenu={hideMenu}
      hideFooter={hideFooter}
      sanityDocument={sanityDocument}
    >
      <SanityLandingPage page={sanityDocument} />
    </StorefrontPage>
  );
};

export default GenericLandingPage;
